<template>
    <hr
        class="ds-divider"
        :class="`ds-divider--${theme}`" />
</template>

<script>
import { theme } from '../../utils/mixins';

/**
 * Divider element
 *
 * @example
 * ```js
 * import { DsDivider } from '../../atoms';
 *
 * export default {
 *   components: { DsDivider },
 *   template: `<div>
 *     <!-- divider light theme -->
 *     <DsDivider />
 *
 *     <!-- divider dark theme -->
 *     <DsDivider theme="dark" />
 *   </div>`;
 * };
 *```
 */
export default {
    name: 'DsDivider',
    mixins: [theme]
};
</script>
